import {
    getObjectById,
    IEventrActivity,
    IOptionsWithTypes,
} from '@eventr/common'
import { Gutters, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { NavigationView } from '../../feat/layout/NavigationView'
import { cardTranslation } from '../../i18n/translateHelpers'
import { bs, useBoundStore } from '../../state/bound.store'
import { loadingSignal } from '../../state/overlayState/overlaySignals'
import { AttendeeList } from '../componentCards/subComponents/attendeeList'
import { RowInfoFiles } from '../componentCards/subComponents/rowInfoFiles'
import { RowInfoNotes } from '../componentCards/subComponents/rowInfoNotes'
import { TickList } from '../componentCards/subComponents/tickList'
import { useFormatValue } from '../hooks/useFormatValue'
import { CardText } from '../componentCards/subComponents/cardText'

export const TodoPage = () => {
    const { _id } = useParams()
    const noEdit = new URLSearchParams(window.location.search).get('noEdit')
    const isNoEdit = noEdit === 'true'
    const { formatValue } = useFormatValue()
    const { activitiesSections, todoStatuses } = useBoundStore(
        useShallow((s) => {
            return {
                activitiesSections: (s?.selectedItinerary?.v2 ?? []).find(
                    (s) => s.sectionID === 8
                ),
                todoStatuses: s.apiUpdates?.todos ?? {},
            }
        })
    )
    const todo = useMemo(() => {
        // setting to empty sting may be a mistake, may need to not send at all
        return getObjectById(
            _id ?? '',
            activitiesSections?.data?.activities ?? []
        ) as IEventrActivity
    }, [_id, activitiesSections?.data?.activities])
    const tickList = useMemo(() => {
        return todo?.tasks?.map((item) => {
            const filler = todoStatuses[item._id]
            return {
                _id: item._id,
                label: item.name,
                completed: filler?.value?.status === 'completed',
                fillerId: filler?.id,
            }
        })
    }, [todo, todoStatuses])

    const fullUserList = useMemo(() => {
        const all: IOptionsWithTypes[] = []
        todo?.attendees_list?.forEach((attendee) => {
            all.push(...(attendee.users ?? []))
        })
        return all
    }, [todo])

    const onClick = async (item: any) => {
        try {
            loadingSignal.value = true
            await bs().updateTodo(item._id, !item.completed, item.fillerId)
        } catch (error) {
        } finally {
            loadingSignal.value = false
        }
    }
    const showAdditional = useMemo(() => {
        return (
            todo?.additional_tasks ||
            todo?.attendees_list?.[0].documents ||
            todo?.attendees_list?.[0].notes
        )
    }, [todo])
    return (
        <NavigationView
            navigationBarTitle={todo?.todo_name}
            backButtonAction={() => {
                window.goBack()
            }}
        >
            <Gutters>
                <Stack spacing={'16px'}>
                    <CardText useMarkdown >
                        {todo?.todo_description}
                    </CardText>
                    {todo?.start_by && todo.start_by !== todo.due_date && (
                        <Typography variant="bodyBold">
                            {cardTranslation('Start by')}{' '}
                            {formatValue(todo.start_by, 'datetime')}
                        </Typography>
                    )}
                    {todo.due_date && (
                        <Typography variant="bodyBold">
                            {cardTranslation('Due by')}{' '}
                            {formatValue(todo.due_date, 'datetime')}
                        </Typography>
                    )}
                    <TickList
                        disabled={isNoEdit}
                        tickList={tickList ?? []}
                        onClick={onClick}
                    />
                    {showAdditional && (
                        <Stack spacing={'8px'}>
                            <Typography variant="bodyBold">
                                {cardTranslation('Additional Information')}
                            </Typography>
                            <RowInfoNotes
                                notes={todo?.attendees_list?.[0].notes ?? ''}
                            />
                            <RowInfoFiles
                                files={
                                    todo?.attendees_list?.[0].documents as any
                                }
                                type="page"
                            />
                        </Stack>
                    )}
                    <AttendeeList
                        userList={fullUserList}
                        showChat
                        title={'People'}
                    />
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
